module.exports = __webpack_public_path__ + "ba1a7f235fc3436bc4fe53fd8912c034.png";